/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AcceptPaymentHistoryResponse = {
    transactionId?: string;
    interestAmount?: number;
    capitalAmount?: number;
    fineAmount?: number;
    transactionType?: AcceptPaymentHistoryResponse.transactionType;
    referenceDate?: string;
    paymentChannelType?: AcceptPaymentHistoryResponse.paymentChannelType;
    isDeletable?: boolean;
};
export namespace AcceptPaymentHistoryResponse {
    export enum transactionType {
        APPOINTMENT = 'APPOINTMENT',
        RECEIVED_PAYMENT = 'RECEIVED_PAYMENT',
        DISBURSED_LOAN = 'DISBURSED_LOAN',
        CONTRACT_FEE = 'CONTRACT_FEE',
        FORECLOSURE_PAYMENT = 'FORECLOSURE_PAYMENT',
    }
    export enum paymentChannelType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
}

